import React from "react";
import PortalModal from "../../../Common/Modal/PortalModal";

const DeleteAddressModal = ({
    modalRef,
    selectedAddress,
    onConfirm,
    onCancel
}) => {


    return (
        <PortalModal ref={modalRef} className="w-4/5 max-w-md">
            {selectedAddress && <div className="card-body">
                <h3 className="card-title text-lg">Confirmer la suppression</h3>
                <p>Êtes-vous sûr de vouloir supprimer cette adresse ?</p>
                <div className="bg-base-200 p-3 rounded-lg mt-2">
                    <p className="font-medium">{selectedAddress.street}</p>
                    <p className="text-sm text-gray-600">
                        {selectedAddress.city}, {selectedAddress.postcode}
                    </p>
                </div>
                <div className="card-actions justify-end mt-4">
                    <button className="btn btn-ghost" onClick={onCancel}>
                        Annuler
                    </button>
                    <button className="btn btn-error" onClick={onConfirm}>
                        Supprimer
                    </button>
                </div>
            </div>}
            {!selectedAddress && <div className="card-body">
                <p>Aucune adresse sélectionnée</p>
                <button className="btn btn-ghost" onClick={onCancel}>
                    Fermer
                </button>
            </div>}
        </PortalModal>
    );
};

export default DeleteAddressModal; 